var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDiscoverMoreIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 9V20C21 20.5523 20.5523 21 20 21H4C3.44772 21 3 20.5523 3 20V4C3 3.44772 3.44772 3 4 3H14.5",
    stroke: "#D2CCC1",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5 1L20.2858 3.41844H22.8287L20.7714 4.91312L21.5572 7.33156L19.5 5.83688L17.4428 7.33156L18.2286 4.91312L16.1713 3.41844H18.7142L19.5 1Z",
    fill: "#D2CCC1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.874 17C15.2352 17 17 15.4189 17 13.7704C17 12.2974 15.7674 11.419 12.6722 10.8109C10.2072 10.3243 9.70295 9.72971 9.70295 9.02718C9.70295 8.21641 10.4873 7.60812 11.8599 7.60812C13.5686 7.60812 14.9411 8.3378 16.0755 9.74337H16.1595V8.68931C16.1595 8.40557 16.1038 8.27036 15.8515 8.12166C14.773 7.50005 13.4985 7 11.8041 7C8.89079 7 7.15411 8.43255 7.15411 10.1758C7.15411 11.865 8.7227 12.5677 11.8041 13.1893C13.7646 13.5812 14.3949 14.1487 14.3949 15.0001C14.3949 15.8649 13.5125 16.3919 11.9579 16.3919C10.2773 16.3919 8.45658 15.6757 7.08405 13.9189H7L7.12598 15.2434C7.15411 15.527 7.23816 15.6622 7.44819 15.7839C8.73668 16.5271 10.2214 17 11.874 17Z",
    fill: "#D2CCC1"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscoverMoreIcon);
export default __webpack_public_path__ + "static/media/discover-more-icon.ed6d0660d6456128ffb3ce8db4274608.svg";
export { ForwardRef as ReactComponent };